import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/privacy-policy/hero";
import PP from "../components/privacy-policy/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Composite Bonding Ilkley Practice</title>
        <link
          rel="canonical"
          href="https://www.compositebonding-ilkley.com/privacy-policy"
        />
        <meta
          name="description"
          content="Your privacy matters at Regent Dental, trusted by patients in Ilkley and Keighley. Discover how we protect your data and uphold the highest care standards."
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
